export const TKeyMessagesContent = {
  MESSAGES_CONTENT_NAV: "MESSAGES_CONTENT_NAV",
  MESSAGES_CONTENT_TITLE: "MESSAGES_CONTENT_TITLE",
  MESSAGES_CONTENT_SUBTITLE: "MESSAGES_CONTENT_SUBTITLE",
  MESSAGES_CONTENT_TAB_SEQUENCES: "MESSAGES_CONTENT_TAB_SEQUENCES",
  MESSAGES_CONTENT_TAB_SCRIPTS: "MESSAGES_CONTENT_TAB_SCRIPTS",
  MESSAGES_CONTENT_SCRIPT_GENERATE_CTA: "MESSAGES_CONTENT_SCRIPT_GENERATE_CTA",
  MESSAGES_CONTENT_SCRIPT_OPENING_PLACEHOLDER: "MESSAGES_CONTENT_SCRIPT_OPENING_PLACEHOLDER",
  MESSAGES_CONTENT_SCRIPT_NEXT_STEP_PLACEHOLDER: "MESSAGES_CONTENT_SCRIPT_NEXT_STEP_PLACEHOLDER",
  MESSAGES_CONTENT_SCRIPT_SOURCES_UPDATED: "MESSAGES_CONTENT_SCRIPT_SOURCES_UPDATED",
  MESSAGES_CONTENT_SCRIPT_SOURCES_REFRESH_CTA: "MESSAGES_CONTENT_SCRIPT_SOURCES_REFRESH_CTA",
  MESSAGES_CONTENT_SCRIPT_CALL_MODE: "MESSAGES_CONTENT_SCRIPT_CALL_MODE",
  MESSAGES_CONTENT_SCRIPT_MOVE_UP: "MESSAGES_CONTENT_SCRIPT_MOVE_UP",
  MESSAGES_CONTENT_SCRIPT_MOVE_DOWN: "MESSAGES_CONTENT_SCRIPT_MOVE_DOWN",
  MESSAGES_CONTENT_SCRIPT_FILTER_PLACEHOLDER: "MESSAGES_CONTENT_SCRIPT_FILTER_PLACEHOLDER",
  MESSAGES_CONTENT_SCRIPT_FILTER_EMPTY: "MESSAGES_CONTENT_SCRIPT_FILTER_EMPTY",
  MESSAGES_CONTENT_SCRIPT_OBJECTIONS_TITLE: "MESSAGES_CONTENT_SCRIPT_OBJECTIONS_TITLE",
  MESSAGES_CONTENT_SCRIPT_QUOTES_EMPTY: "MESSAGES_CONTENT_SCRIPT_QUOTES_EMPTY",
  MESSAGES_CONTENT_SCRIPT_PAINS_TITLE: "MESSAGES_CONTENT_SCRIPT_PAINS_TITLE",
  MESSAGES_CONTENT_SCRIPT_PAIN_QUESTION_PLACEHOLDER:
    "MESSAGES_CONTENT_SCRIPT_PAIN_QUESTION_PLACEHOLDER",
  MESSAGES_CONTENT_SCRIPT_QUESTION_ADD: "MESSAGES_CONTENT_SCRIPT_QUESTION_ADD",
  MESSAGES_CONTENT_SCRIPT_QUESTION_PLACEHOLDER: "MESSAGES_CONTENT_SCRIPT_QUESTION_PLACEHOLDER",
  MESSAGES_CONTENT_SCRIPT_RESPONSE_PLACEHOLDER: "MESSAGES_CONTENT_SCRIPT_RESPONSE_PLACEHOLDER",
  MESSAGES_CONTENT_SCRIPT_OBJECTION_ADD: "MESSAGES_CONTENT_SCRIPT_OBJECTION_ADD",
  MESSAGES_CONTENT_SCRIPT_OBJECTION_PLACEHOLDER: "MESSAGES_CONTENT_SCRIPT_OBJECTION_PLACEHOLDER",
  MESSAGES_CONTENT_SCRIPT_BLOCK_OPENING: "MESSAGES_CONTENT_SCRIPT_BLOCK_OPENING",
  MESSAGES_CONTENT_SCRIPT_BLOCK_QUESTIONS: "MESSAGES_CONTENT_SCRIPT_BLOCK_QUESTIONS",
  MESSAGES_CONTENT_SCRIPT_BLOCK_OBJECTIONS: "MESSAGES_CONTENT_SCRIPT_BLOCK_OBJECTIONS",
  MESSAGES_CONTENT_SCRIPT_BLOCK_NEXT_STEP: "MESSAGES_CONTENT_SCRIPT_BLOCK_NEXT_STEP",
  MESSAGES_CONTENT_TAB_CONTENTS: "MESSAGES_CONTENT_TAB_CONTENTS",
  MESSAGES_CONTENT_SEQUENCE_EMPTY: "MESSAGES_CONTENT_SEQUENCE_EMPTY",
  MESSAGES_CONTENT_CARD_TITLE: "MESSAGES_CONTENT_CARD_TITLE",
  MESSAGES_CONTENT_CARD_DESCRIPTION: "MESSAGES_CONTENT_CARD_DESCRIPTION",
  MESSAGES_CONTENT_CARD_CTA: "MESSAGES_CONTENT_CARD_CTA",
  MESSAGES_CONTENT_SELECT_OFFER_LABEL: "MESSAGES_CONTENT_SELECT_OFFER_LABEL",
  MESSAGES_CONTENT_SELECT_AVATAR_LABEL: "MESSAGES_CONTENT_SELECT_AVATAR_LABEL",
  MESSAGES_CONTENT_NO_AVATAR_BADGE: "MESSAGES_CONTENT_NO_AVATAR_BADGE",
  MESSAGES_CONTENT_NO_AVATAR_TITLE: "MESSAGES_CONTENT_NO_AVATAR_TITLE",
  MESSAGES_CONTENT_NO_AVATAR_DESCRIPTION: "MESSAGES_CONTENT_NO_AVATAR_DESCRIPTION",
  MESSAGES_CONTENT_NO_AVATAR_BUTTON: "MESSAGES_CONTENT_NO_AVATAR_BUTTON",
  MESSAGES_CONTENT_CHANNEL_LABEL: "MESSAGES_CONTENT_CHANNEL_LABEL",
  MESSAGES_CONTENT_CHANNEL_LINKEDIN: "MESSAGES_CONTENT_CHANNEL_LINKEDIN",
  MESSAGES_CONTENT_CHANNEL_EMAIL: "MESSAGES_CONTENT_CHANNEL_EMAIL",
  MESSAGES_CONTENT_CHANNEL_WHATSAPP: "MESSAGES_CONTENT_CHANNEL_WHATSAPP",
  MESSAGES_CONTENT_STEP_OPENING: "MESSAGES_CONTENT_STEP_OPENING",
  MESSAGES_CONTENT_STEP_FOLLOW_UP_1: "MESSAGES_CONTENT_STEP_FOLLOW_UP_1",
  MESSAGES_CONTENT_STEP_FOLLOW_UP_2: "MESSAGES_CONTENT_STEP_FOLLOW_UP_2",
  MESSAGES_CONTENT_STEP_FOLLOW_UP_3: "MESSAGES_CONTENT_STEP_FOLLOW_UP_3",
  MESSAGES_CONTENT_STEP_BREAK_UP: "MESSAGES_CONTENT_STEP_BREAK_UP",
  MESSAGES_CONTENT_ADD_STEP: "MESSAGES_CONTENT_ADD_STEP",
  MESSAGES_CONTENT_ADD_STEP_PLACEHOLDER: "MESSAGES_CONTENT_ADD_STEP_PLACEHOLDER",
  MESSAGES_CONTENT_DELETE_STEP: "MESSAGES_CONTENT_DELETE_STEP",
  MESSAGES_CONTENT_EDIT_STEP: "MESSAGES_CONTENT_EDIT_STEP",
  MESSAGES_CONTENT_STEP_MODAL_ADD_TITLE: "MESSAGES_CONTENT_STEP_MODAL_ADD_TITLE",
  MESSAGES_CONTENT_STEP_MODAL_EDIT_TITLE: "MESSAGES_CONTENT_STEP_MODAL_EDIT_TITLE",
  MESSAGES_CONTENT_STEP_ADD_CTA: "MESSAGES_CONTENT_STEP_ADD_CTA",
  MESSAGES_CONTENT_STEP_ALREADY_USED: "MESSAGES_CONTENT_STEP_ALREADY_USED",
  MESSAGES_CONTENT_STEP_TYPE_LABEL: "MESSAGES_CONTENT_STEP_TYPE_LABEL",
  MESSAGES_CONTENT_STEP_DELAY_LABEL: "MESSAGES_CONTENT_STEP_DELAY_LABEL",
  MESSAGES_CONTENT_STEP_DELAY_PLACEHOLDER: "MESSAGES_CONTENT_STEP_DELAY_PLACEHOLDER",
  MESSAGES_CONTENT_TEMPLATE_LABEL: "MESSAGES_CONTENT_TEMPLATE_LABEL",
  MESSAGES_CONTENT_TEMPLATE_PLACEHOLDER: "MESSAGES_CONTENT_TEMPLATE_PLACEHOLDER",
  MESSAGES_CONTENT_TEMPLATE_HINT: "MESSAGES_CONTENT_TEMPLATE_HINT",
  MESSAGES_CONTENT_STEP_AI_RULES_LABEL: "MESSAGES_CONTENT_STEP_AI_RULES_LABEL",
  MESSAGES_CONTENT_STEP_AI_RULES_PLACEHOLDER: "MESSAGES_CONTENT_STEP_AI_RULES_PLACEHOLDER",
  MESSAGES_CONTENT_REGENERATE_STEP: "MESSAGES_CONTENT_REGENERATE_STEP",
  MESSAGES_CONTENT_REGENERATE_STEP_MODAL_TITLE: "MESSAGES_CONTENT_REGENERATE_STEP_MODAL_TITLE",
  MESSAGES_CONTENT_REGENERATE_STEP_DESCRIPTION: "MESSAGES_CONTENT_REGENERATE_STEP_DESCRIPTION",
  MESSAGES_CONTENT_REGENERATE_STEP_CTA: "MESSAGES_CONTENT_REGENERATE_STEP_CTA",
  MESSAGES_CONTENT_DELETE_STEP_TITLE: "MESSAGES_CONTENT_DELETE_STEP_TITLE",
  MESSAGES_CONTENT_DELETE_STEP_TEXT: "MESSAGES_CONTENT_DELETE_STEP_TEXT",
  MESSAGES_CONTENT_DELETE_STEP_CONFIRM: "MESSAGES_CONTENT_DELETE_STEP_CONFIRM",
  MESSAGES_CONTENT_DELAY_DAY: "MESSAGES_CONTENT_DELAY_DAY",
  MESSAGES_CONTENT_DELAY_HOUR: "MESSAGES_CONTENT_DELAY_HOUR",
  MESSAGES_CONTENT_DELAY_MINUTE: "MESSAGES_CONTENT_DELAY_MINUTE",
  MESSAGES_CONTENT_DELAY_UNIT_LABEL: "MESSAGES_CONTENT_DELAY_UNIT_LABEL",
  MESSAGES_CONTENT_DELAY_UNIT_DAY: "MESSAGES_CONTENT_DELAY_UNIT_DAY",
  MESSAGES_CONTENT_DELAY_UNIT_HOUR: "MESSAGES_CONTENT_DELAY_UNIT_HOUR",
  MESSAGES_CONTENT_DELAY_UNIT_MINUTE: "MESSAGES_CONTENT_DELAY_UNIT_MINUTE",
  MESSAGES_CONTENT_GENERATE_MODAL_TITLE: "MESSAGES_CONTENT_GENERATE_MODAL_TITLE",
  MESSAGES_CONTENT_GENERATE_DESCRIPTION: "MESSAGES_CONTENT_GENERATE_DESCRIPTION",
  MESSAGES_CONTENT_REGENERATE_MODAL_TITLE: "MESSAGES_CONTENT_REGENERATE_MODAL_TITLE",
  MESSAGES_CONTENT_VARIANTS_COUNT_LABEL: "MESSAGES_CONTENT_VARIANTS_COUNT_LABEL",
  MESSAGES_CONTENT_VARIANT_ONE: "MESSAGES_CONTENT_VARIANT_ONE",
  MESSAGES_CONTENT_VARIANT_MANY: "MESSAGES_CONTENT_VARIANT_MANY",
  MESSAGES_CONTENT_GENERATE_ERROR: "MESSAGES_CONTENT_GENERATE_ERROR",
  MESSAGES_CONTENT_REGENERATE_DESCRIPTION: "MESSAGES_CONTENT_REGENERATE_DESCRIPTION",
  MESSAGES_CONTENT_MENU_VARIANT_SECTION: "MESSAGES_CONTENT_MENU_VARIANT_SECTION",
  MESSAGES_CONTENT_MENU_STEP_SECTION: "MESSAGES_CONTENT_MENU_STEP_SECTION",
  MESSAGES_CONTENT_GUIDE_TITLE: "MESSAGES_CONTENT_GUIDE_TITLE",
  MESSAGES_CONTENT_GUIDE_STEP_1: "MESSAGES_CONTENT_GUIDE_STEP_1",
  MESSAGES_CONTENT_GUIDE_STEP_2: "MESSAGES_CONTENT_GUIDE_STEP_2",
  MESSAGES_CONTENT_GUIDE_STEP_3: "MESSAGES_CONTENT_GUIDE_STEP_3",
  MESSAGES_CONTENT_GUIDE_STEP_4: "MESSAGES_CONTENT_GUIDE_STEP_4",
  MESSAGES_CONTENT_GUIDE_INSTALL: "MESSAGES_CONTENT_GUIDE_INSTALL",
  MESSAGES_CONTENT_GUIDE_DESCRIPTION: "MESSAGES_CONTENT_GUIDE_DESCRIPTION",
  MESSAGES_CONTENT_GUIDE_LEAD: "MESSAGES_CONTENT_GUIDE_LEAD",
  MESSAGES_CONTENT_GUIDE_SIGNUP: "MESSAGES_CONTENT_GUIDE_SIGNUP",
  MESSAGES_CONTENT_VARIANT: "MESSAGES_CONTENT_VARIANT",
  MESSAGES_CONTENT_ADD_VARIANT: "MESSAGES_CONTENT_ADD_VARIANT",
  MESSAGES_CONTENT_EDIT_VARIANT: "MESSAGES_CONTENT_EDIT_VARIANT",
  MESSAGES_CONTENT_DELETE_VARIANT: "MESSAGES_CONTENT_DELETE_VARIANT",
  MESSAGES_CONTENT_VARIANT_MODAL_ADD_TITLE: "MESSAGES_CONTENT_VARIANT_MODAL_ADD_TITLE",
  MESSAGES_CONTENT_VARIANT_MODAL_EDIT_TITLE: "MESSAGES_CONTENT_VARIANT_MODAL_EDIT_TITLE",
  MESSAGES_CONTENT_VARIANT_LABEL_LABEL: "MESSAGES_CONTENT_VARIANT_LABEL_LABEL",
  MESSAGES_CONTENT_VARIANT_LABEL_PLACEHOLDER: "MESSAGES_CONTENT_VARIANT_LABEL_PLACEHOLDER",
  MESSAGES_CONTENT_DELETE_VARIANT_TITLE: "MESSAGES_CONTENT_DELETE_VARIANT_TITLE",
  MESSAGES_CONTENT_DELETE_VARIANT_TEXT: "MESSAGES_CONTENT_DELETE_VARIANT_TEXT",
  MESSAGES_CONTENT_DELETE_VARIANT_CONFIRM: "MESSAGES_CONTENT_DELETE_VARIANT_CONFIRM",
  MESSAGES_CONTENT_OBJECTIVE_LABEL: "MESSAGES_CONTENT_OBJECTIVE_LABEL",
  MESSAGES_CONTENT_OBJECTIVE_PLACEHOLDER: "MESSAGES_CONTENT_OBJECTIVE_PLACEHOLDER",
  MESSAGES_CONTENT_OBJECTIVE_ADD: "MESSAGES_CONTENT_OBJECTIVE_ADD",
  MESSAGES_CONTENT_OBJECTIVE_EDIT: "MESSAGES_CONTENT_OBJECTIVE_EDIT",
  MESSAGES_CONTENT_OBJECTIVE_ADD_TITLE: "MESSAGES_CONTENT_OBJECTIVE_ADD_TITLE",
  MESSAGES_CONTENT_OBJECTIVE_EDIT_TITLE: "MESSAGES_CONTENT_OBJECTIVE_EDIT_TITLE",
  MESSAGES_CONTENT_OBJECTIVE_DESCRIPTION: "MESSAGES_CONTENT_OBJECTIVE_DESCRIPTION",
  MESSAGES_CONTENT_OBJECTIVE_NAME_LABEL: "MESSAGES_CONTENT_OBJECTIVE_NAME_LABEL",
  MESSAGES_CONTENT_OBJECTIVE_DETAIL_LABEL: "MESSAGES_CONTENT_OBJECTIVE_DETAIL_LABEL",
  MESSAGES_CONTENT_OBJECTIVE_DETAIL_PLACEHOLDER: "MESSAGES_CONTENT_OBJECTIVE_DETAIL_PLACEHOLDER",
  MESSAGES_CONTENT_OBJECTIVE_DELETE_TITLE: "MESSAGES_CONTENT_OBJECTIVE_DELETE_TITLE",
  MESSAGES_CONTENT_OBJECTIVE_DELETE_TEXT: "MESSAGES_CONTENT_OBJECTIVE_DELETE_TEXT",
  MESSAGES_CONTENT_OBJECTIVE_DELETE_CONFIRM: "MESSAGES_CONTENT_OBJECTIVE_DELETE_CONFIRM",
  MESSAGES_CONTENT_OBJECTIVE_LIMIT: "MESSAGES_CONTENT_OBJECTIVE_LIMIT",
  MESSAGES_CONTENT_OBJECTIVE_EMPTY_TITLE: "MESSAGES_CONTENT_OBJECTIVE_EMPTY_TITLE",
  MESSAGES_CONTENT_OBJECTIVE_EMPTY_TEXT: "MESSAGES_CONTENT_OBJECTIVE_EMPTY_TEXT",
  MESSAGES_CONTENT_OBJECTIVE_EMPTY_EXAMPLES: "MESSAGES_CONTENT_OBJECTIVE_EMPTY_EXAMPLES",
  MESSAGES_CONTENT_OBJECTIVE_EMPTY_READER: "MESSAGES_CONTENT_OBJECTIVE_EMPTY_READER",
  MESSAGES_CONTENT_OBJECTIVE_SUGGESTION_1: "MESSAGES_CONTENT_OBJECTIVE_SUGGESTION_1",
  MESSAGES_CONTENT_OBJECTIVE_SUGGESTION_2: "MESSAGES_CONTENT_OBJECTIVE_SUGGESTION_2",
  MESSAGES_CONTENT_OBJECTIVE_SUGGESTION_3: "MESSAGES_CONTENT_OBJECTIVE_SUGGESTION_3",
  MESSAGES_CONTENT_OBJECTIVE_SUGGESTION_4: "MESSAGES_CONTENT_OBJECTIVE_SUGGESTION_4",
  MESSAGES_CONTENT_OBJECTIVE_SUGGESTION_5: "MESSAGES_CONTENT_OBJECTIVE_SUGGESTION_5",
  MESSAGES_CONTENT_OBJECTIVE_SUGGESTION_6: "MESSAGES_CONTENT_OBJECTIVE_SUGGESTION_6",
  MESSAGES_CONTENT_OBJECTIVE_SUGGESTION_7: "MESSAGES_CONTENT_OBJECTIVE_SUGGESTION_7",
  MESSAGES_CONTENT_OBJECTIVE_SUGGESTION_8: "MESSAGES_CONTENT_OBJECTIVE_SUGGESTION_8",
  MESSAGES_CONTENT_AI_RULES_LABEL: "MESSAGES_CONTENT_AI_RULES_LABEL",
  MESSAGES_CONTENT_AI_RULES_PLACEHOLDER: "MESSAGES_CONTENT_AI_RULES_PLACEHOLDER",
  MESSAGES_CONTENT_GENERATING: "MESSAGES_CONTENT_GENERATING",
  MESSAGES_CONTENT_GENERATE_CTA: "MESSAGES_CONTENT_GENERATE_CTA",
  MESSAGES_CONTENT_REGENERATE_CTA: "MESSAGES_CONTENT_REGENERATE_CTA",
  MESSAGES_CONTENT_AVATAR_UPDATED: "MESSAGES_CONTENT_AVATAR_UPDATED",
} as const;
